<template>
  <div class="mobile-container">
    <div class="mobile-logo">
      <img src="@/assets/weavr-logo.svg">
    </div>
    <div class="mobile-title">
      Weavr
    </div>
    <div class="mobile-subtitle">
      <div class="subtitle-item">
        A LIGHTHEARTED GAME
      </div>
      <div class="subtitle-item">
        TO KEEP YOUR TEAM CONNECTED
      </div>
    </div>
    <div class="mobile-message">
      <div class="message-item">
        Weavr is not yet available
      </div>
      <div
        class="message-item"
        :style="{ paddingBottom: '1em' }"
      >
        for mobile or tablet.
      </div>
      <div class="message-item">
        Please visit weavr.cc on
      </div>
      <div class="message-item">
        your laptop or desktop to play.
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'MobileHomeView'
})
</script>

<style scoped lang="scss">
.mobile-container {
  font-size: min(12px, 2vh, 2vw);  /* overwrite App.vue dynamic font-size */
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 2em;
  min-height: max-content;
  background-color: $eigengrau;
}

.mobile-logo {
  height: 12em;
  width: 12em;
}

.mobile-logo > img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.mobile-title {
  font-size: 8em;
  color: $natural-white;
}

.mobile-subtitle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  color: $light-teal;
  padding-top: 0.8em;
  padding-bottom: 1.4em;
  margin: 0 auto;
}

.subtitle-item {
  flex: 1;
  margin: 0 auto;
}

.mobile-message {
  text-align: center;
  border-radius: 0.4em;
  color: $natural-white;
  background-color: $brand-teal;
  padding: 1em 1.2em;
  margin-top: 1em;
  font-size: 1.8em;
  box-shadow: 0 6px 8px -4px $smoke-gray;
}

.message-item {
  flex: 1;
  margin: 0 auto;
}
</style>
